import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CurrentAffairsComponent } from './current-affairs/current-affairs.component';
import { AddUpdateCurrentAffairsComponent } from './add-update-current-affairs/add-update-current-affairs.component';

const routes: Routes = [
  {
    path: '',
    component: CurrentAffairsComponent
  },
  {
    path: 'add',
    component: AddUpdateCurrentAffairsComponent
  },
  {
    path: 'update/:id',
    component: AddUpdateCurrentAffairsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CurrentAffairRoutingModule { }
